import { assetPrefix } from "@/vars/assetUrl";

const AsFeatured = () => {
  const featureds = [
    {
      image: "rmid.png",
      alt: "rm.id",
      url: "https://rm.id/baca-berita/ekonomi-bisnis/140570/hadir-di-acara-bergengsi-internasional-tahunan-icann-meeting-sid-memperkenalkan-url-shortener-dan-tool-bio-link",
    },
    {
      image: "tempo-co.png",
      alt: "tempo.co",
      url: "https://www.tempo.co/digital/platform-s-id-tangkal-ratusan-ribu-tautan-berbahaya-hampir-seluruhnya-menyangkut-phising--1198198",
    },
    {
      image: "medicom.png",
      alt: "medicom.id",
      url: "https://mediaindonesia.com/teknologi/515876/tiga-fitur-yang-jadi-keunggulan-sid",
    },
    {
      image: "liputan6.png",
      alt: "liputan6.com",
      url: "https://www.liputan6.com/tekno/read/5893639/platform-sid-berhasil-raih-15-juta-pengguna-aktif-dan-143-miliar-pengunjung-microsite?page=3",
    },
    {
      image: "detikinet.png",
      alt: "detikinet",
      url: "https://inet.detik.com/cyberlife/d-6245404/kenalan-platform-penyingkat-tautan-sid-dan-cara-menggunakannya",
    },
    {
      image: "mashable.png",
      alt: "mashable.com",
      url: "https://id.mashable.com/tech/13417/sid-shop-revolusi-toko-digital-untuk-creator-indonesia-di-tengah-ekspansi-ekonomi-digital",
    },
    {
      image: "timesindonesia.png",
      alt: "timesindonesia.co.id",
      url: "https://timesindonesia.co.id/ekonomi/547080/sid-luncurkan-sid-shop-fitur-toko-digital-untuk-creator-indonesia",
    },
    {
      image: "kumparan.png",
      alt: "kumparan.com",
      url: "https://kumparan.com/kumparantech/platform-pemendek-link-s-id-pandi-tembus-1-5-juta-pengguna-di-dunia-24Mq7ychHP5/1",
    },
    {
      image: "tirto.png",
      alt: "tirto.id",
      url: "https://tirto.id/platform-digital-sid-tembus-15-juta-pengguna-g7GX",
    },
    {
      image: "merdeka-com.png",
      alt: "merdeka.com",
      url: "https://www.merdeka.com/teknologi/platform-sid-tembus-15-juta-pengguna-289055-mvk.html?page=3",
    },
    {
      image: "antaranews.png",
      alt: "antaranews.com",
      url: "https://www.antaranews.com/berita/4607074/didukung-komdigi-platform-sid-tembus-15-juta-pengguna",
    },
    {
      image: "sindonews.png",
      alt: "sindonews.com",
      url: "https://tekno.sindonews.com/read/782295/207/pembuatan-microsite-sid-2022-wadah-content-creator-berkreasi-1653753953",
    },
    {
      image: "media-indonesia.png",
      alt: "mediaindonesia.com",
      url: "https://mediaindonesia.com/teknologi/515876/tiga-fitur-yang-jadi-keunggulan-sid",
    },
  ];

  return (
    <div className="group [mask-image:linear-gradient(to_right,_rgba(0,_0,_0,_0),rgba(0,_0,_0,_1)_10%,rgba(0,_0,_0,_1)_90%,rgba(0,_0,_0,_0))] flex flex-row py-2 max-w-full overflow-hidden [--gap:1rem] [gap:var(--gap))] [--duration:50s]">
      {Array(4)
        .fill(0)
        .map((_, i) => (
          <div
            className="flex flex-row justify-around animate-marquee shrink-0 [gap:var(--gap)]"
            key={i}
          >
            {featureds.map((item, index) => (
              <div key={index}>
                <a
                  href={item.url}
                  className="opacity-50 hover:opacity-100 grayscale hover:grayscale-0 transition-all"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={assetPrefix + `images/featured/${item.image}`}
                    alt={item.alt}
                    className="h-10 sm:h-[4.2rem]"
                  />
                </a>
              </div>
            ))}
          </div>
        ))}
    </div>
  );
};

export default AsFeatured;
